import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import tmdbApi from "../api/tmdbApi";
import { contentContext } from "../context/contentContext";
import SweetAlert from "react-bootstrap-sweetalert";
const SubscriptionPayment = ({ className, navigation }) => {
    const location = useLocation(); // Get the current route
    const { setUserData } = useContext(contentContext)
    const [errorMsg, setErrorMsg] = useState(false);
    const [showThankYou, setShowThankYou] = useState(false);
    const [razorpayKey, setRazorpayKey] = useState(null);
    const [success, setSuccess] = useState(false);
    const [plans, setPlans] = useState([])
    const [userHasSubscription, setUserHasSubscription] = useState(null);
    const onClickSelection = (index) => {
        const token = localStorage.getItem("token");
        localStorage.setItem("selectedPlan", JSON.stringify(plans[index]));
        console.log("Selected plan:", plans[index]);
        setPendingPlanIndex(index);
        console.log('indexxxxxxxx', index)
        setSelectedPlanIndex(index);
        if (token) {
            setShowConfirmAlert(true);
        } else {
            navigate('/login');
        }



    };
    const [selectedPlanIndex, setSelectedPlanIndex] = useState(0); // default to first plan selected
    const [showConfirmAlert, setShowConfirmAlert] = useState(false);
    const [pendingPlanIndex, setPendingPlanIndex] = useState(null);
    const navigate = useNavigate();
    const okayErrorFn = () => {
        setErrorMsg(false);
    }
    const okaySuccesFn = () => {
        const libraryId = localStorage.getItem("libraryId");
        if (libraryId) {
            navigate('/lecture-library')
        } else {

            navigate('/cpc');
        }
        setSuccess(false);

    }
    const getPlans = async () => {
        // Check if user already has a subscription
        let userInfo = await tmdbApi.getUserData();
        let subscriptionId = null;
        if (userInfo?.statusCode === 200 && userInfo?.result?.[0]) {
            subscriptionId = userInfo?.result?.[0]?.subscriptionplanid;
        }
        if (subscriptionId) {
            setUserHasSubscription(true);
            setPlans([]);
        } else {
            setUserHasSubscription(false);
            let planstmp = await tmdbApi.getPlans();
            setPlans(planstmp?.result || []);
            const id = localStorage.getItem("libraryId")
            if (id) {
                setSelectedPlanIndex(3); // Always select the first plan by default
            } else {
                setSelectedPlanIndex(0);
            }


        }
        setUserData(userInfo?.result?.[0]);
    }
    const amoutFrmt = (amount) => {
        const formattedAmount = new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            maximumFractionDigits: 0,
        }).format(amount);
        return formattedAmount;
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        getPlans();

        const fetchConfig = async () => {
            const response = await tmdbApi.configData();
            if (response?.result && response?.result.length > 0) {
                setRazorpayKey(response?.result[0]?.RAZORPAY_KEY_ID);
            }
        };
        fetchConfig();


    }, []);

    useEffect(() => {
        console.log('userHasSubscriptionnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnn', userHasSubscription)
        if (userHasSubscription === null) return; // wait until it's loaded

        const token = localStorage.getItem("token");
        const pendingPlan = JSON.parse(localStorage.getItem("selectedPlan"));
        const libraryId = localStorage.getItem("libraryId");
        if (pendingPlan && token) {
            if (!userHasSubscription) {
                console.log("Pending plan found:", pendingPlan);
                setShowConfirmAlert(true);

                const planMap = {
                    "3 Months Plan": 0,
                    "6 Months Plan": 1,
                    "12 Months Plan": 2,
                };

                setPendingPlanIndex(planMap[pendingPlan.duration] ?? -1);
            } else {
                setSuccess(true);
            }

            localStorage.removeItem("selectedPlan");
        } else if (userHasSubscription && libraryId) {
            setSuccess(true)
        }
    }, [userHasSubscription]);





    console.log("plans", plans);
    const loadRazorpay = async (data) => {

        try {

            let amount = Number(data?.price) * 100;

            let res = await tmdbApi.subscriptionPayments(data.subscriptionplanid);
            let id = res?.result?.razorpayOrder?.id;

            const paymentAmount = amount;
            const paymentCurrency = "INR";

            // const paymentKey = RAZORPAY_KEY_ID;
            const options = {
                key: razorpayKey,
                amount: paymentAmount,
                currency: paymentCurrency,
                display_currency: "INR",

                name: "Dadi",
                description: "CPC Subscription",
                order_id: id,
                handler: async function (response) {
                    console.log(response);
                    // Handle success/error response here
                    let signature = response?.razorpay_signature;
                    // Fallback: try to get signature from window or other sources if not present
                    if (!signature && window?.razorpay_signature) {
                        signature = window.razorpay_signature;
                    }
                    // Always send signature, even if empty string
                    let obj = {
                        razorpay_payment_id: response?.razorpay_payment_id || "",
                        razorpay_order_id: response?.razorpay_order_id || "",
                        razorpay_signature: signature || "",
                        type: "subscription",
                        subscriptionplanid: data?.subscriptionplanid || "",
                    };
                    // Only treat as success if both payment_id and signature are present
                    const isPaymentSuccess = !!(response?.razorpay_payment_id && signature);
                    if (isPaymentSuccess) {
                        obj.message = "Payment successful";
                        let verificationData = await tmdbApi.verifyPayments(data?.id, null, JSON.stringify(obj),id);
                        if (
                            response?.razorpay_order_id &&
                            verificationData?.result?.gatewayPaymentId &&
                            verificationData?.statusCode === 200
                        ) {
                            // Fetch user data after successful payment verification
                            await tmdbApi.getUserData();
                            setShowThankYou(true);
                        } else {
                            setErrorMsg(true);
                            return;
                        }
                    } else {
                        // Add error reason if available
                        let reason = response?.error || response?.reason || "Payment failed or was cancelled.";
                        let failed = {
                            message: `Payment failed: ${reason}`,
                        };
                        await tmdbApi.verifyPayments(data?.id, null, JSON.stringify(failed),id,"FAILED");
                        setErrorMsg(true);
                        return;
                    }


                },
                prefill: {
                    name: localStorage.getItem("name") || "User Name",
                    email: localStorage.getItem("email") || "",
                    contact: localStorage.getItem("contact") || "9999999999",
                },
                notes: {
                    address: localStorage.getItem("email"),
                },
                theme: {
                    color: "#3399cc",
                },
                modal: {
                    ondismiss: async function () {
                        // Handle payment modal close/cancel
                        let failed = {
                            message: `Payment Cancelled`,
                        };
                        await tmdbApi.verifyPayments(data?.id, null, JSON.stringify(failed),id,"CANCELLED");
                        setErrorMsg(true);
                        return;
                    }
                }
            };
            if (window.Razorpay) {
                const rzp = new window.Razorpay(options);
                rzp.open();
            } else {
                alert("Razorpay SDK not loaded");
            }
        } catch (err) {
            alert("Failed to initiate payment");
            console.error(err);
        }
    };
    const handleclick = async (data, value) => {
        console.log('data', data);
        const token = localStorage.getItem("token");

        if (token && data !== undefined) {
            if (data.subscriptionplanid) {
                let userInfo = await tmdbApi.getUserData();
                let subscriptionId = null;
                let subscriptionEndDate = null;
                if (userInfo?.statusCode === 200 && userInfo?.result?.[0]) {
                    subscriptionId = userInfo?.result?.[0]?.subscriptionplanid;
                    subscriptionEndDate = userInfo?.result?.[0]?.subscriptionenddate;
                }
                if (!subscriptionId) {
                    try {
                        await loadRazorpay(data);
                    } catch (error) {
                        console.error("Error during payment process:", error);
                        setErrorMsg(true);
                    }
                } else {
                    // Check if subscription is active (e.g., based on end date)
                }
            }
        }

        // else {
        //     // Save the current page, selected plan, and pending action in localStorage
        //     localStorage.setItem("redirectTo", location.pathname); // Use dynamic route
        //     if (data?.subscriptionplanid) {
        //         localStorage.setItem("selectedPlan", JSON.stringify(data));
        //         localStorage.setItem("pendingAction", "pay");
        //     }

        // }
    }

    useEffect(() => {
        // debugger
        // Check for pending payment action after login
        const pendingPlan = localStorage.getItem("selectedPlan");
        const pendingAction = localStorage.getItem("pendingAction");

        if (pendingPlan && pendingAction === "pay") {
            const planData = JSON.parse(pendingPlan);
            loadRazorpay(planData)
                .catch((error) => {
                    console.error("Error during automatic payment process:", error);
                    setErrorMsg(true);
                })
                .finally(() => {
                    // Clear pending action from localStorage
                    localStorage.removeItem("selectedPlan");
                    localStorage.removeItem("pendingAction");
                });
        }
    }, []);

    return (

        <div className={`cpc-subscription  ${className}`}>
            {showConfirmAlert && (
                <div className="confirm-subscription-alert">
                    <SweetAlert
                        title="Confirm Subscription"
                        onConfirm={() => {
                            setShowConfirmAlert(false);
                            handleclick(plans[pendingPlanIndex], pendingPlanIndex);
                        }}
                        onCancel={() => {
                            setShowConfirmAlert(false);
                            setPendingPlanIndex(null);
                        }}
                        onClose={() => {
                            setShowConfirmAlert(false);
                            setPendingPlanIndex(null);
                        }}
                        customButtons={[
                            <button
                                key="proceed"
                                className="btn btn-primary"
                                onClick={() => {

                                    setShowConfirmAlert(false);
                                    handleclick(plans[pendingPlanIndex], pendingPlanIndex);
                                }}
                            >
                                Proceed
                            </button>,
                            <button
                                key="cancel"
                                className="btn btn-secondary"
                                style={{ marginLeft: 8 }}
                                onClick={() => {
                                    localStorage.removeItem("selectedPlan");
                                    setShowConfirmAlert(false);
                                    setPendingPlanIndex(null);
                                }}
                            >
                                Cancel
                            </button>
                        ]}
                    >
                        <span>
                            Do you want to proceed with this subscription plan?
                        </span>
                    </SweetAlert>
                </div>


            )}

            <div className="cpc-subscription-heading container">
                {/* <p className="adv_lrn">CPC Subscription</p> */}
                <h3 className="sub_title">DADI Online Dermatopathology Fellowship</h3>
                <p className="txt-16 text-muted cpc-head-para">
                    <span>Flexible training program with tiered options.</span>
                    All tiers include access to <span className="d-block">the full slide collection.</span>
                </p>
            </div>

            <div className="cpc-subscription-section">
                {userHasSubscription ? (
                    <div className="alert alert-success" style={{ margin: '30px 0', textAlign: 'center' }}>
                        You already have an active subscription. Thank you!
                    </div>
                ) : (
                    <div className="row plans">
                        {plans.length > 0 && plans.map((plan, index) => (
                            <div className="col-md-3" key={index}>
                                <div className={`basic_plan ${selectedPlanIndex === index ? "active_plan" : ""}`}>
                                    <h6 className="price-txt">{amoutFrmt(plan.price)}</h6>
                                    <h6 className="months-plan-txt">{plan.duration}</h6>
                                    <p className="plan-desc">{plan.description}</p>
                                    {plan.points.map((point, idx) => (
                                        <div className="points" key={idx}>
                                            {point && point?.trim() !== "" && <span className="material-symbols-outlined check-icons">chevron_right</span>}
                                            <p>{point}</p>
                                        </div>
                                    ))}
                                    <div className="Plan-select-footer">
                                        <button
                                            className={`stroke-btn ${selectedPlanIndex === index ? "fill-btn" : ""}`}
                                            onClick={() => onClickSelection(index)}

                                        >

                                            Select
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <div className="cpc-points mt-5">
                <p className="txt-16 cpc-head-para">Eligibility: <span>“MD/DNB Dermatologists & Pathologists only.”</span></p>
                <p className="txt-16 cpc-head-para">Subscription: <span>Monthly billing; 30-day cancellation notice for 3/6-month tiers; 12/24-month tiers offer 2 or 4 installments.</span></p>
                <p className="txt-16 cpc-head-para">Start Date: 3/6 months: <span>Enroll anytime, begins upon payment; 12/24 months: Set cohort start date (TBD).</span></p>
                <p className="txt-16 cpc-head-para">CTA: <span>“Apply Now” form (name, email, CV upload, statement of purpose, select tier).</span></p>
            </div>
            <SweetAlert
                show={errorMsg}
                custom
                customclassName="cpc-alert"
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title="payment failed or cancelled"
                onConfirm={() => okayErrorFn()}
                id="error-alert"
            />
            <SweetAlert
                show={success}
                custom
                customclassName="cpc-alert"
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title="You already have an active subscription."
                onConfirm={() => okaySuccesFn()}
                id="error-alert"
            />
            <SweetAlert
                show={showThankYou}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title="Thank you for your subscription!"
                onConfirm={() => {
                    setShowThankYou(false);
                    navigate('/fellowshipmodules')
                    getPlans(); // Reload the component state

                }}
                id="thankyou-alert"
            >
                <span>Your subscription is now active. Enjoy your access!</span>
            </SweetAlert>
        </div>
    );
};

export default SubscriptionPayment;
